import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import mh2Ratings from "../../../../src/data/articles/cube-prospective-modern-horizons-2/mh2-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  mh2Ratings,
  ProspectiveIntro,
  React
};